import React from 'react';
import { useNavigate, useParams, Link } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import { authService } from '../../services/auth/authService';
import { DashboardHeader } from '../../components/layout/DashboardHeader/DashboardHeader';
import { DashboardSidebar } from '../../components/layout/DashboardSidebar/DashboardSidebar';
import { createSidebarItems } from '../../components/layout/DashboardSidebar/sidebarItems';
import PatientMealPlanTab from './PatientMealPlanTab';
import './PatientDetailPage.css';

/** Standalone view of one meal plan (no diet plan context). Route: /patients/:patientId/daily-meals-plan/:planId */
const MealPlanStandaloneViewPage: React.FC = () => {
  const navigate = useNavigate();
  const { patientId, planId } = useParams<{ patientId: string; planId: string }>();

  if (!authService.isAuthenticated()) return null;

  const sidebarItems = createSidebarItems(navigate, window.location.pathname);
  const backUrl = patientId ? `/patients/${patientId}?tab=mealPlan&showMealPlans=true` : '/patients';

  return (
    <div className="dashboard">
      <DashboardHeader onProfileClick={() => navigate('/profile')} onLogout={() => navigate('/login')} />
      <div className="dashboard-layout">
        <DashboardSidebar items={sidebarItems} />
        <div className="dashboard-container">
          <main className="dashboard-main-content">
            <div className="section-card">
              <nav className="detail-breadcrumb" aria-label="Breadcrumb">
                <Link to="/patients" className="breadcrumb-link">Patients</Link>
                <span className="breadcrumb-sep">›</span>
                {patientId && (
                  <>
                    <Link to={`/patients/${patientId}`} className="breadcrumb-link">Patient</Link>
                    <span className="breadcrumb-sep">›</span>
                    <span className="breadcrumb-current">Meal Plan</span>
                  </>
                )}
              </nav>
              <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 12 }}>
                <h2 className="section-title" style={{ margin: 0 }}>Meal Plan</h2>
                <button
                  type="button"
                  onClick={() => navigate(backUrl)}
                  className="secondary-button"
                  style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}
                >
                  <ChevronLeft size={16} /> Back to list
                </button>
              </div>
              <div style={{ padding: 12 }}>
                <PatientMealPlanTab
                  patientId={Number(patientId)}
                  mealPlanViewMode="view"
                  mealPlanIdFromUrl={planId}
                  hideBackToList
                />
              </div>
            </div>
          </main>
        </div>
      </div>
    </div>
  );
};

export default MealPlanStandaloneViewPage;
